module.exports = __webpack_public_path__ + "static/media/person.85282cc2.mp4";